export default __webpack_public_path__ + "static/media/rimpic5.089d3807.jpg";